import React, { useCallback, useMemo } from 'react';
import DT from 'duration-time-conversion';
import cn from 'classnames';
import { parseTime } from '../../../../shared/utils';
import Logger from '../../../../services/Logger';

const KeywordsMarkers = ({
  data, handleLeftStickyMarker, handleRightStickyMarker, handleCommentMarker, setCurrentTime, assetId,
}) => {
  /** We need to combine markers with the same startTime */
  const preparedData = useMemo(() => {
    const combinedMarkers = {};
    data.forEach((kw, index) => {
      const { startTime } = kw;
      if (!combinedMarkers[startTime]) {
        combinedMarkers[startTime] = [];
      }
      combinedMarkers[startTime].push({ index, ...kw });
    });
    return Object.values(combinedMarkers);
  }, [data]);

  const handleClick = useCallback((startTime, value) => () => {
    const time = DT.t2d(startTime);
    Logger.log('User', 'PreviewTimelineKeywordsTimeCodeClicked', {
      assetId,
      timestamp_sec: time,
      entity_value: value,
    });
    setCurrentTime(DT.t2d(startTime));
  }, [assetId, setCurrentTime]);

  return preparedData.map((kw) => (
    <div
      key={kw[0].index}
      className={cn('itemMarker', {
        leftStickyMarker: handleLeftStickyMarker(kw[0], 'startTime'),
        rightStickyMarker: handleRightStickyMarker(kw[0], 'startTime'),
      })}
      style={{ left: `${handleCommentMarker(kw[0], 'startTime')}%` }}
      role="presentation"
      onClick={handleClick(kw[0].startTime, kw.map((item) => item.text).join(' | '))}
    >
      <div className="itemMarkerData">
        {kw.map((item) => (
          <div key={item.index} className="itemMarkerDataText">
            <div className="itemMarkerDataTitle">
              <span className="itemMarkerDataTextTime">
                {parseTime(DT.t2d(item.startTime))}
                <If condition={item.endTime}>
                  {' '}- {parseTime(DT.t2d(item.endTime))}
                </If>
              </span>
              {' '}{item.text}
            </div>
          </div>
        ))}
      </div>
    </div>
  ));
};
export default KeywordsMarkers;
